<div class="pos-rel" jsdaddyLetsDoWork [routerLink]="contactUs">
    <img
        width="2560"
        height="1042"
        [ngSrc]="'lets-do' | asset: 'shared/lets-do-work' : true"
        alt="Lets do work" />
</div>
